import { createSlice } from "@reduxjs/toolkit";

export const intialComplaintLocalState = {
  complaint_id: null,
  lead_id: null,
  service_name: null,
  service_id: null,
  reported_date: null,
  reported_by: null,
  handled_by: null,
  title: null,
  description: null,
  priority: null,
  costs: null,
  recovered: null,
  status: "Initiated",
};

const initialState = {
  users: [],
  complaints: [],
  leadCompaints: [],
  complaintTasks: [],
  complaintCosts: [],
  complaintInProgress: [],
  singleComplaint: null,
  newComplaintLocal: intialComplaintLocalState,
  pagination: {},
  isAddComplaintCostSuccess: false,
  isAddComplaintSuccess: false,
  isUpdateComplaintSuccess: false,
  isDeleteComplaintSuccess: false,
  complaintInProgressResponse: false,
};

export const complaintSlice = createSlice({
  name: "complaint",
  initialState,
  reducers: {
    getAllComplaintsAction: (state, { payload }) => {},
    setAllComplaintsAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, complaints = [] } = payload;
      state.complaints = complaints;
      state.pagination = pagination;
    },

    addComplaintAction: (state, { payload }) => {},
    setAddComplaintResponse: (state, { payload }) => {
      state.isAddComplaintSuccess = payload;
    },

    getLeadComplaintAction: (state, { payload }) => {},
    getLeadComplaintResponseAction: (state, { payload }) => {
      state.leadCompaints = payload;
    },

    updateComplaintAction: (state, { payload }) => {},
    setUpdateComplaintResponse: (state, { payload }) => {
      state.isUpdateComplaintSuccess = payload;
    },

    deleteComplaintAction: (state, { payload }) => {},
    setDeleteComplaintResponse: (state, { payload }) => {
      state.isDeleteComplaintSuccess = payload;
    },

    getComplaintByIdAction: (state, { payload }) => {},
    getComplaintByIdResponseAction: (state, { payload }) => {
      state.singleComplaint = payload;
    },

    getComplaintTaskAction: (state, { payload }) => {},
    setComplaintTaskResponseAction: (state, { payload }) => {
      state.complaintTasks = payload;
    },

    getComplaintCostsAction: (state, { payload }) => {},
    setComplaintCostsResponseAction: (state, { payload }) => {
      state.complaintCosts = payload;
    },

    getComplaintInProgressAction: (state, { payload }) => {},
    setComplaintInProgressResponseAction: (state, { payload }) => {
      state.complaintInProgress = payload;
    },

    addComplaintInProgressAction: (state, { payload }) => {},
    setAddComplaintInProgressResponseAction: (state, { payload }) => {
      state.complaintInProgressResponse = payload;
    },

    addComplaintCostAction: (state, { payload }) => {},
    setAddComplaintCostResponseAction: (state, { payload }) => {
      state.isAddComplaintCostSuccess = payload;
    },

    deleteComplaintTaskAction: (state, { payload }) => {},
    setDeleteComplaintTaskResponse: (state, { payload }) => {
      state.isDeleteComplaintSuccess = payload;
    },

    setNewComplaintLocal: (state, action) => {
      state.newComplaintLocal = action.payload;
    },
    resetNewComplaintLocal: (state) => {
      state.newComplaintLocal = intialComplaintLocalState;
    },
  },
});

const {
  getAllComplaintsAction,
  setAllComplaintsAction,
  addComplaintAction,
  setAddComplaintResponse,
  updateComplaintAction,
  setUpdateComplaintResponse,
  setNewComplaintLocal,
  resetNewComplaintLocal,
  deleteComplaintAction,
  setDeleteComplaintResponse,
  getLeadComplaintAction,
  getLeadComplaintResponseAction,
  getComplaintByIdAction,
  getComplaintByIdResponseAction,
  getComplaintTaskAction,
  setComplaintTaskResponseAction,
  getComplaintCostsAction,
  setComplaintCostsResponseAction,
  getComplaintInProgressAction,
  setComplaintInProgressResponseAction,
  deleteComplaintTaskAction,
  setDeleteComplaintTaskResponse,
  addComplaintCostAction,
  setAddComplaintCostResponseAction,
  addComplaintInProgressAction,
  setAddComplaintInProgressResponseAction,
} = complaintSlice.actions;

export {
  getAllComplaintsAction,
  setAllComplaintsAction,
  addComplaintAction,
  setAddComplaintResponse,
  updateComplaintAction,
  setUpdateComplaintResponse,
  setNewComplaintLocal,
  resetNewComplaintLocal,
  deleteComplaintAction,
  setDeleteComplaintResponse,
  getLeadComplaintAction,
  getLeadComplaintResponseAction,
  getComplaintByIdAction,
  getComplaintByIdResponseAction,
  getComplaintTaskAction,
  setComplaintTaskResponseAction,
  getComplaintCostsAction,
  setComplaintCostsResponseAction,
  getComplaintInProgressAction,
  setComplaintInProgressResponseAction,
  deleteComplaintTaskAction,
  setDeleteComplaintTaskResponse,
  addComplaintCostAction,
  setAddComplaintCostResponseAction,
  addComplaintInProgressAction,
  setAddComplaintInProgressResponseAction,
};

export default complaintSlice.reducer;
